import React, { useMemo } from 'react';
import VoucherCard from '../gift-cards-v2/VoucherCard';
import { buildPreviewVoucher } from './shopUtils';
// VoucherCard renders `.v2-card`, whose styles are scoped under `.voucher-v2`
// in the V2 stylesheet — so we import it here and wrap the card in that class.
import '../gift-cards-v2/GiftCardsV2.css';

// GiftCardPreview — the live card that anchors the whole shop. Renders the
// chosen design at the chosen amount (read-only VoucherCard), with a gift
// frame (To / message / From) below once the buyer personalises it.
const GiftCardPreview = ({
  design,
  amount,
  currency = '£',
  salonName,
  recipientName,
  message,
  fromName,
}) => {
  const previewVoucher = useMemo(
    () => buildPreviewVoucher(design, amount),
    [design, amount]
  );
  const hasGiftFrame = !!(recipientName || message || fromName);

  return (
    <div className="gcs-preview">
      <div className="voucher-v2 gcs-preview-card">
        <VoucherCard
          voucher={previewVoucher}
          aesthetic={design?.aesthetic || 'custom'}
          salonName={salonName}
          currency={currency}
          showPromo={false}
        />
      </div>

      {hasGiftFrame && (
        <div className="gcs-gift-frame">
          {recipientName && <div className="gcs-gift-to">To {recipientName}</div>}
          {message && <p className="gcs-gift-message">{message}</p>}
          {fromName && <div className="gcs-gift-from">From {fromName}</div>}
        </div>
      )}
    </div>
  );
};

export default GiftCardPreview;
